// utils/request.ts
import axios from 'axios'

// 定义响应类型
export interface ApiResponse<T = any> {
  msgCode: string | number
  message: string
  sysMessage: string
  responseData: T
  ext: Record<string, any>
  iTotalRecords: number
  iTotalDisplayRecords: number
  traceId: string
}

// 创建axios实例
const request = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截器 - 移除了状态判断逻辑，直接返回完整响应
request.interceptors.response.use(
  (response) => {
    if(response.status === 200) {
      return response.data
    }
    // return response
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default request
export const get = <T = any>(url: string, params?: any): Promise<ApiResponse<T>> => {
  return request.get(url, { params })
}

export const post = <T = any>(url: string, data?: any): Promise<ApiResponse<T>> => {
  return request.post(url, data)
}